import {MainException} from 'common/exception/MainException';
import {ExceptionContract} from 'common/exception/ExceptionContract';

export class BadParameterException extends MainException implements ExceptionContract {
    public constructor(message: string, data?: {[key: string]: any}) {
        super(message, 400, data);
        this.name = 'BadParameterException';
    }
}
